import logo from "../public/img/logo.png"
import { Packages } from "../StaticData/Packages"
import { numberContact } from "../variables"
import PackageTable from "../Component/Body/PackageTable"
import MainButton from "../Component/Button/MainButton"
import ButtonContactUs from "../Component/Button/ContactUsButton"
import { Card, CardBody, CardFooter, CardHeader, Input } from "reactstrap"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { urlQueryParamsHandler, verifyLength } from "../Service/Helper/Utils"
import swal from "sweetalert"
import { HomeNavigation } from "../Service/API/Auth/AuthValidation"
import UserService from "../Service/API/UserService"
import { companyName } from "../version"

function LandingPages() {
    const navigation = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const id = urlQueryParamsHandler(searchParams.get("ids"))
    const isUseParams = !id
    const currentPath = location.pathname
    const [customerId, setCustomerId] = useState(id)
    const userService = useMemo(() => new UserService(), [])

    const handleLogout = useCallback(async () => {
      try {
        await userService.LogOut()
      } catch (error) {
        console.log(error.message)
      }
    }, [userService])

    useEffect(() => {
        const openPrefilledLogin = async () => {
            if (isUseParams) return
            await handleLogout()
            navigation(`/login?id=${customerId}`)
        }
        openPrefilledLogin()
    }, [customerId, handleLogout, isUseParams, navigation])

    useEffect(() => {
        HomeNavigation(navigation, currentPath)
    }, [currentPath, navigation])

    function handleClick () {
        if (!customerId) {
            swal("Masukkan ID Layanan Anda", "ID layanan ada di tagihan WhatsApp atau email pelanggan.", "info")
            return
        }
        handleLogout()
        navigation(`/login?id=${customerId}`)
    }

    function handleClickContactUs () {
        window.open(numberContact, "_blank")
    }

    function handlePackageSelect(pkg) {
        const params = new URLSearchParams()
        params.set("package", pkg.name)
        params.set("speed", pkg.speed)
        params.set("price", pkg.price)
        navigation(`/register/new?${params.toString()}`)
    }

    return (
        <>
            <main className="landing-page">
                <section className="landing-hero">
                    <div className="landing-hero-bg" />
                    <div className="landing-container landing-hero-grid">
                        <div className="landing-copy">
                            <div className="landing-brand-chip">
                                <img src={logo} alt="Goodnet Logo" />
                                <span>{companyName}</span>
                            </div>
                            <h1>Internet cepat stabil dan handal</h1>
                            <p>
                                Pilih paket sesuai kebutuhan keluarga Anda.
                            </p>
                            <div className="landing-actions">
                                <a className="landing-primary-link" href="#paket-internet">Lihat Paket</a>
                                <button className="landing-secondary-link" onClick={handleClickContactUs}>Hubungi Kami</button>
                            </div>
                            <div className="landing-proof-grid">
                                <div><strong>Unlimited</strong><span>Tampa Limit FUP</span></div>
                                <div><strong>24 Jam</strong><span>NOC Helpdesk Support</span></div>
                                <div><strong>QRIS / VA Bank</strong><span>Pembayaran Aman dan Praktis</span></div>
                            </div>
                        </div>

                        <Card>
                            <CardHeader>
                                <h4>Cek tagihan Anda</h4>
                            </CardHeader>
                            <CardBody>
                                <Input
                                    className="landing-service-input"
                                    placeholder="Nomor Layanan"
                                    value={customerId}
                                    disabled={!isUseParams}
                                    onChange={(e) => {
                                        if (!verifyLength(e.target.value, 13)) {
                                            setCustomerId(e.target.value)
                                        }
                                    }}
                                />
                            </CardBody>
                            <CardFooter className="card-footer-centered">
                                <MainButton
                                    className="landing-text-button"
                                    title="Cek Tagihan"
                                    onClick={handleClick}
                                />

                                <a className="landing-text-button"
                                    href = '#paket-internet'
                                >
                                    Belum berlangganan? Daftar Sekarang
                                </a>
                            </CardFooter>

                        </Card>
                    </div>
                </section>

                <section className="landing-section landing-container">
                    <div className="landing-section-title">
                        <span>Kenapa pilih kami</span>
                        <h2>Layanan Internet Cepat sesuai kebutuhan anda.</h2>
                    </div>
                    <div className="landing-feature-grid">
                        <div>
                            <i className="fa fa-gamepad" />
                            <strong>Stabil</strong>
                            <p>Koneksi internet Stabil untuk kebutuhan anda</p>
                        </div>
                        <div>
                            <i className="fa fa-wifi" />
                            <strong>NOC Support</strong>
                            <p>24 Jam NOC Support</p>
                        </div>
                        <div>
                            <i className="fa fa-credit-card" />
                            <strong>Pembayaran mudah</strong>
                            <p>Pembayaran mudah dengan berbagai metode pembayaran</p>
                        </div>
                    </div>
                </section>

                <section id="paket-internet" className="landing-section landing-package-section">
                    <div className="landing-container">
                        <div className="landing-section-title center">
                            <h2>Paket Internet</h2>
                            <p>Pilih paket sesuai kebutuhan Anda.</p>
                        </div>
                        <PackageTable
                            data={Packages}
                            handleClick={handlePackageSelect}
                        />
                    </div>
                </section>

                {/* <section className="landing-section landing-container">
                    <div className="landing-coverage">
                        <div>
                            <span>Cakupan Area</span>
                            <h2>Cek ketersediaan jaringan di lokasi Anda.</h2>
                            <p>Masukkan data alamat saat registrasi. Tim kami akan memvalidasi coverage, ODP terdekat, dan jadwal pemasangan.</p>
                        </div>
                        <a className="landing-primary-link" href = '#paket-internet'>
                            Daftar Sekarang
                        </a>
                    </div>
                </section> */}

                <section className="landing-cta">
                    <div className="landing-container">
                        <h2>Butuh bantuan memilih paket?</h2>
                        <p>Tim kami siap membantu cek kebutuhan perangkat, coverage, kendala jaringan dan estimasi pemasangan.</p>
                        <ButtonContactUs
                            title="Hubungi Kami"
                            onClick={handleClickContactUs}
                            size="lg"
                        />
                    </div>
                </section>
            </main>
        </>
    )
}

export default LandingPages
